export const HomebannersEndpoint = {
  RETRIEVE_BANNER_GROUPS: '/api/admin/homescreenbanner/groups',
  RETRIEVE_HOMEBANNERS_BY_GROUP: '/api/admin/homescreenbanner/:groupName',
  CREATE_HOMEBANNER: '/api/admin/homescreenbanner',
  EDIT_HOMEBANNER: '/api/admin/homescreenbanner',
  DELETE_HOMEBANNER: '/api/admin/homescreenbanner/:id',
  UPDATE_BANNER_SEQUENCE: '/api/admin/homescreenbanner/:groupName',
};
